import type { ActionHandler } from '../types';
import { invokeSemanticPort, readString } from './helpers';

export const startCheckoutHandler: ActionHandler = {
  type: 'start_checkout',
  execute(ctx) {
    const config = ctx.config;
    const port = ctx.semanticPorts?.startCheckout;
    const rawMode = readString(config, 'mode');
    const mode = rawMode === 'buy_now' ? 'buy_now' : rawMode === 'cart' ? 'cart' : undefined;
    return invokeSemanticPort(
      ctx,
      'start_checkout',
      port
        ? (context) => port({ cartId: readString(config, 'cartId', 'cart_id'), mode }, context)
        : undefined
    );
  },
};
